import React from "react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"];

/**
 * Keypad for the cash handed over. Kept on screen so the cashier never has to
 * summon the device keyboard, which would cover the change due.
 *
 * Laid out left to right in every language — it is a number pad, and a
 * mirrored one would put the keys where no hand expects them.
 *
 * `compact` trims the keys for the side panel, where the ticket lines and the
 * totals share the same column.
 */
const CashKeypad = ({ onPress, compact = false }) => (
  <div dir="ltr" className={`grid grid-cols-3 ${compact ? "gap-1.5" : "gap-2"}`}>
    {KEYS.map((key) => (
      <button
        key={key}
        type="button"
        onClick={() => onPress(key)}
        className={`rounded-xl bg-slate-800 border border-slate-700 font-bold text-white hover:bg-slate-700 active:scale-95 transition-all ${
          compact ? "h-11 text-lg" : "h-12 text-xl"
        }`}
      >
        {key}
      </button>
    ))}
  </div>
);

export default CashKeypad;
